export default __webpack_public_path__ + "static/media/ic-edit.8695ebb5.svg";